export enum CountryCodes {
  US = 1,
  Canada = 2,
}

// Country code string constants
export const CountryCodeStrings = {
  US: "US",
  USA: "USA",
  CA: "CA",
  CANADA: "CANADA",
}

export type SortDirection = "asc" | "desc";
export enum SortType {
  ASC = "asc",
  DESC = "desc",
}

export enum TrialStatus {
  created = "created",
  published = "published",
  assigned = "assigned",
  deleted = "deleted",
  active = "Active",
  Created = "Created",
}

export enum TrialEvent {
  Publish = "publish",
  Unpublish = "unpublish",
}

export enum Treatment {
  Yes = "Yes",
  No = "No",
}

export enum RandomizationTypeEnum {
  RCB = "RCB",
  RCB_With_Grouping = "RCB with Grouping",
  None = "None",
}

export enum TreatmentTypeEnum {
  split_plot = "Split Plot",
  factorial = "Factorial",
}
export const StageTypes = [
  {
    name: "Commercial",
  },
  {
    name: "Experimental",
  },
];
export const IrrigationList = [
  { name: "true", label: "Yes" },
  { name: "false", label: "No" },
];

export const ArtificialDrainageList = [
  { name: "true", label: "Yes" },
  { name: "false", label: "No" },
];

export enum FieldsType {
  TextInput = "textinput",
  RM = "rm",
  DropDown = "dropdown",
  Date = "date",
}
export enum ColumnType {
  Text = "text",
  CheckBox = "checkbox",
  DropDown = "dropdown",
  Date = "date",
  TextField = "textField",
  DeleteButton = "deleteButton",
  SelectAllCheckbox = "selectAllCheckbox",
}

export enum ModulesName {
  User = "User",
  Team = "Team",
  Crop = "Crop",
  Season = "Season",
  Product = "Product",
  Location = "Location",
  Attribute = "Attribute",
  Inventory = "Inventory",
  Trial = "Trial",
  UserGroup = "UserGroup",
  TreatmentGroup = "TreatmentGroup",
  TreatmentProduct = "TreatmentProduct",
  DemoTrial = "demoTrial",
  DemoInventory = "DemoInventory",
  TrialLocation = "TrialLocation",
  Worksheet = "Worksheet",
  DataCollection = "DataCollection",
  Protocol = "Protocol",
  Printing = "Printing",
  FieldMap = "FieldMap",
  FieldBook = "FieldBook",
  RepBook = "RepBook",
  ObservationBook = "ObservationBook",
  RatingBook = "RatingBook",
  ApplicationBook = "ApplicationBook",
  SoilSampleBook = "SoilSampleBook",
  TissueSampleBook = "TissueSampleBook",
  NematodeSampleBook = "NematodeSampleBook",
  EntryLevel = "EntryLevel",
  RepLevel = "RepLevel",
  MasterLocation = "MasterLocation",
  MasterTreatmentProduct = "MasterTreatmentProduct",
  PendingTreatmentProduct = "PendingTreatmentProduct",
  MasterProduct = "MasterProduct",
  OnFarmProduct = "OnFarmProduct",
  OnFarmPendingProduct = "OnFarmPendingProduct",
  OnFarmTrialExperiments = "OnFarmTrialExperiments",
  Add_Inventory_Product = "Add_Inventory_Product",
  Trial_Add_Inventory_Product = "Trial_Add_Inventory_Product",
  Stakes="Stakes",
  BarCode="Barcode",
  Trial_Substitute_Inventory = "Trial_Substitute_Inventory",
  DemoFieldBook = "DemoFieldBook",
  Demo = "demo",
  DEMO_TRIAL_DETAIL = 'DEMO_TRIAL_DETAIL',
  DemoBarCode = "DemoBarCode",
  // OnFarm-specific modules
  TrialExperiments = "Trial Experiment",
  TrialDetail="Trial Detail",
  Reports = "Reports",
  Regions = "Region",
  AgronomicData = "onFarmAgronomicData",
  HarvestData = "onFarmHarvestData",
  HARVEST_DATA = "Harvest Data",
  AGRONOMIC_DATA = "Agronomic Data",
  MasterCatalog = "MasterCatalog",
  RepBookCatalog = "RepBookCatalog",
  Catalog = "Catalog",
  FieldBookCatalog = "FieldBookCatalog",
  DemoFieldBookCatalog = "DemoFieldBookCatalog",
  DemoTrialDetail = "DemoTrialDetail",
  RepBookcatalog = "repBookcatalog",
  TRIAL_DETAIL = "TrialDetail",
  TASK_PLANNER = "TaskPlanner",
  TRIAL_BOOK = "TrialBook",
  FIELD_REP = "FieldRep",
}

export enum AttributeDatatype {
  Text = "Text",
  Number = "Number",
  File = "File",
  Date = "Date",
  Flag = "Flag",
  LOV = "LOV",
  JSON = "Json",
  INT = "Int",
}
export enum StoreBucket {
  Image = "image",
  Pdf = "pdf",
  Zip = "zip",
}

export const metaDataCollection = [
  {
    NAME: "Application Book",
  },
  {
    NAME: "Soil Book",
  },
  {
    NAME: "Tissue Book",
  },
  {
    NAME: "Observation Book",
  },
  {
    NAME: "Rep List",
  },
  {
    NAME: "Silage Book"
  }
];

export enum AttributeTypes {
  field_book = "field_book",
  Rep = "rep",
  Observation = "observation",
  RatingBook = "rating",
  Application = "application",
  Soil = "soil_sample",
  Tissue = "tissue_sample",
  Nematode = "nematode",
  Protocol = "Protocol",
  Location = "location",
  Location_metadata = "location_metadata",
  Demo = "demo",
  OnFarmAgronomicData = "onFarm_agronomic_data",
  OnFarmHarvest= "onFarm_harvest",
  C_SUPPLIER = "C_SUPPLIER",
  Inventory= "inventory",
}
export enum ExportTypes {
  Brand = "brand",
  Field_book = "field_book",
  Location = "location",
  Product = "product",
  MasterLocation = "masterLocation",
  MasterTreatments = "masterTreatment",
  MasterTreatmentProduct = "masterTreatmentProduct",
  Inventory = "inventory",
  Trials = "trials",
  TrialLocation = "trialLocation",
  Treatments = "treatments",
  Stakes = "Stakes",
  Rep_book = "rep_book,",
  Observation_book = "observationBook",
  Rating_book = "RatingBook",
  Application_book = "application_book",
  Soil_sample = "soil_sample",
  Tissue_sample = "tissue_sample",
  Nematode_sample = "nematode_sample",
  EntryMeans = "entryMeansReport",
  DemoTrial = "demoTrial",
  OnFarmAgronomicData = "onFarmAgronomicData",
  OnFarmHarvestData = "onFarmHarvestData",
  RepBookCatalog = "repbookcatalog",
  Field_Book_Catalog = "FieldBookCatalog",
  TaskPlanner = "taskPlanner",
  TrialBook = "trialBook",
  FieldRep = "fieldRep",
}

export enum LabBookSampleTypes {
  TISSUE = "tissue",
  SOIL = "soil",
  NEMATOD = "nematode",
}
export enum ProtocolStatus {
  Published = "Published",
  Assigned = "Assigned",
  Draft = "Draft",
}
export enum ResourceType { // notes and pictures
  TrialLocation = "triallocation",
  TrialRep = "trialrep",
  TrialFieldjournal = "trialfieldjournal",
  Receipt = "receipt",
  Protocol = "protocol",
  OnFarmAgronomicData="onFarm_agronomic_data",
  OnFarmHarvestData="onFarm_harvest_data",
}
export enum NotePictureType {
  Notes = "notes",
  Picture = "picture",
}

export enum MeasurementType {
  Weight = "Weight",
  Count = "Count",
}

export enum CropType {
  Soybeans = "SOYBEANS",
  CORN = "CORN",
  SUNFLOWER = "SUNFLOWER",
}

export const YesNoOption = [
  {
    label: "Yes",
    value: "true",
  },
  {
    label: "No",
    value: "false",
  },
];

export const dataCollection = [
  { name: "In-Season", dataKey: "C_IN_SEASON" },
  { name: "Harvest", dataKey: "C_HARVEST" },
  { name: "Imagery Flight", dataKey: "C_IMAGERY_FLIGHT" },
  { name: "Weed Control", dataKey: "C_WEED_CONTROL" },
];
export const MeasuredList = [
  { value: MeasurementType.Weight, label: "Weight" },
  { value: MeasurementType.Count, label: "Count" },
];

export enum LogicalOperator {
  AND = "AND",
  OR = "OR",
}

export enum OperatorType {
  EQUAL = "eq",
  NOT_EQUAL = "neq",
  BETWEEN = "bt",
  NOT_IN_LIST = "nin",
  IN_LIST = "in",
  STARTS_WITH = "sw",
  ENDS_WITH = "ew",
  CONTAINS = "ct",
  GREATER_THAN = "gt"
}

export enum FilterSchemaType {
  TRIAL_AUTH = "TRIAL_AUTH",
  DATA_COLLECTION = "DATA_COLLECTION",
  MASTER_DATA = "MASTER_DATA",
  TRIAL_MASTER = "TRIAL_MASTER",
  TRIAL_REPORT = "TRIAL_REPORT",
  COLLECTION_MASTER = "COLLECTION_MASTER"
}

export enum ReportType {
  ENTRY_MEANS = "entrymeans",
  QC_REPORT = "qcreport",
  REP_MEANS = "repmeans",
  OUTLIER_REPORT = "outlierreport",
  H2H_TYPE = "h2htype",
}

export enum ReportModalType {
  COMMERCIAL_ENTRY = "Commercial Entry Means Report",
  PRODUCT_MANAGER = "Product Manager Report",
  QC = "QC Report",
  Rep_Means = "Rep Means Report",
  Outlier = "Outlier Report",
  H2H = "Head to Head Type",
}

export enum LocationType {
  NATIONAL = "National",
  REGIONAL = "Regional",
  LOCATION_WISE = "Location Wise",
}

export enum Lsd {
  ALPHA_005 = 0.05,
  ALPHA_010 = 0.10,
}

export enum TrialTypeEnum {
  RESEARCH = "Research",
  DEMO = "Demo",
}


export const TrialTypeList = [
  { label: "Research", value: TrialTypeEnum.RESEARCH },
  { label: "Demo", value: TrialTypeEnum.DEMO },
];

export enum MasterCatalogFilterTypeEnum {
  TEAM = "team",
  STATE = "state",
  LOCATION = "location",
}
export enum ExportReportData {
  INDIVIDUAL = "selected",
  CONSOLIDATED = "all",
}

export const RegionList = [
  "Northwest",
  "NE/CO/KS",
  "RRV",
  "MN/SD",
  "Central",
  "East",
  "Coastal",
];
export enum PrintingJobStatus {
  Running = "Running",
  Summary = "Summary",
  Success = "Success",
  Failed = "Failed",
  Queued = "Queued"
}

export enum UserRoles {
  SystemAdmin = "System Admin",
  FieldAdmin = "Field Admin",
  FieldAssociate = "Field Associate",
  ReportingAssociate = "Reporting Associate",
  Kiosk = "Kiosk User"
}

export const MasterCatalogAllowedRoles = [
  UserRoles.SystemAdmin,
  UserRoles.FieldAdmin,
  UserRoles.Kiosk
]

export const RestrictPatterns = {
  C_BLOCK_NAME: /^[A-MO-Za-mo-z]*$/,
  ALLOW_CHAR: /^[A-Za-z]*$/
};

export const ATTRIBUTE_MASTER_CATALOG_PREFIX_MAP: Record<string, string> = {
  "Rep_Attributes.": "repAttributes",
  "Attributes.": "attributes",
};

export enum HarvestMethod {
  COMBINE = "Combine",
  YIELD_MONITOR = "Yield Monitor",
}

